import axios from 'axios'
import { env } from '../configs/Config'
import openNotification from '../components/common/Notification/openNotification '
import { attachAuthInterceptors } from './auth-interceptor'

export const apiLandingCMSWithToken = axios.create({
  baseURL: env.api_url_landing,
  withCredentials: false,
  timeout: 20000,
  headers: {
    'content-type': 'application/json; charset=utf-8'
  }
})

attachAuthInterceptors(apiLandingCMSWithToken, { defaultTokenKey: 'tokenWeb' })

apiLandingCMSWithToken.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 403) {
      openNotification('error', 'Không có quyền, vui lòng đăng nhập lại')
      setTimeout(() => {
        localStorage.clear()
        window.location.href = '/'
      }, 3000)
    } else if (error.response?.status === 500) {
      openNotification('error', 'Lỗi hệ thống, vui lòng thử lại sau')
    } else if (error.response?.status === 405) {
      openNotification('error', 'Tài khoản của bạn đã đăng nhập trên thiết bị khác')
      setTimeout(() => {
        localStorage.clear()
        window.location.href = '/'
      }, 3000)
    }

    return Promise.reject(error)
  }
)
